var _defs, _circle, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPastCorrections(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_3",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.52 42.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dot",
    cx: 22.334,
    cy: 17.528,
    r: 1.445
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M37.33 20.343a17.342 17.342 0 01-7.218 15.03c-7.797 5.597-18.663 3.809-24.238-3.998C.276 23.578 2.052 12.744 9.849 7.147a17.259 17.259 0 0112.12-3.14"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M41.002 22.947l-3.417-4.467-4.468 3.949"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M17.887 26.423h11.057"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M16.528 25.867l-2.471-2.471a1.865 1.865 0 010-2.656l9.883-9.883a1.865 1.865 0 012.656 0l2.471 2.471a1.865 1.865 0 010 2.656l-9.883 9.883c-.741.741-1.977.741-2.656 0zM17.207 17.528l5.127 5.189"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M13.903 30.07l-.803 1.668M10.934 26.67l-1.73-.494"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPastCorrections);
export default __webpack_public_path__ + "static/media/pastCorrections.fe9764d8c99d434a1f773ec0ce4fa0bb.svg";
export { ForwardRef as ReactComponent };